import { Component, OnInit } from '@angular/core';
// import { Auth } from '../../auth/auth.service';

// import { AuthService } from '@auth0/auth0-angular';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    isAuthenticated = false;

    constructor(public router: Router, public oidcSecurityService: OidcSecurityService) { }

    ngOnInit() {
        // this.oidcSecurityService.isAuthenticated$.subscribe(
        //     ({ isAuthenticated }) => {
        //       this.isAuthenticated = isAuthenticated;
        //       if(!isAuthenticated) {
        //       }
        //       console.warn('authenticated: ', isAuthenticated);
        //     }
        //   );
        // if(this.router.url == '/logout'){
            // this.auth.logout();
            // console.log('logout')
            // this.logout();
            // this.router.navigate(['/login']);
        // }
        // else{
            this.login();
            // if (this.auth.isAuthenticated() === true) {
            //     // this.auth.login();
            //     this.router.navigate(['/dashboard']);
            // } else {
            //     if(this.router.url.indexOf('signup') != -1){
            //         this.auth.signup();
            //     }else{
            //         this.auth.login();
            //     }
            //     // this.auth.renewToken();
                
            // }
        // }
    }

    login(): void {
        this.oidcSecurityService.authorize();
      }

    // logout(): void {
    //     console.log('logout')
    //     this.oidcSecurityService.logoff().subscribe((result)=> {
    //         console.log(result);
    //     });
    // }
}
